export default "__VITE_ASSET__1iWz$QCc__"